module.exports = __webpack_public_path__ + "img/worker.84be0b0.png";